import { ILeadResponseModel } from '@crm-lead/base';

import { IStateWithLead } from './types';

export const getLead = (
  state: IStateWithLead,
  leadId: number
): ILeadResponseModel | undefined => state.leadCore[leadId];

export const getIsLeadLoading = (state: IStateWithLead) =>
  state.leadCore.isLeadLoading;
